exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".blocks .container .article-blocks .texto{color:#222831;font-size:1.6em;line-height:24px;width:100%!important;margin:0 auto 25px}.blocks .container .article-blocks .topico{gap:35px;width:90%;display:flex;margin-bottom:30px;flex-direction:column;align-items:flex-start;justify-content:space-between;border-bottom:1px solid #ddd}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f94c9208","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/politicaDePrivacidade/politicaDePrivacidade.vue
// module id = 168
// module chunks = 0